<main
  class="h-screen bg-white flex flex-col lg:flex-row lg:overflow-hidden"
  role="main"
  aria-label="Sistema de autenticación"
>
  <!-- Titulo Principal oculto pero indexable -->
  <h1 class="absolute left-[-9999px]">Iniciar Sesión | Allas Repuestos</h1>
  <!-- Authentication Steps Container -->
  <section
    class="w-full lg:w-2/5 flex flex-col px-4 py-6 overflow-y-auto relative"
    aria-live="polite"
    aria-label="Pasos de autenticación"
  >
    <!-- Botón VOLVER -->
    <div class="absolute top-0 left-0 pl-4 pt-4 w-full bg-white">
      @if (currentStateType === LoginState.login) {
      <a
        href="/"
        class="flex items-center gap-2 text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
        aria-label="Volver a la página principal"
        title="Volver"
      >
        <svg
          class="w-7 h-7 text-red-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          ></path>
        </svg>
        <span class="text-base font-extralight fs-condensed">VOLVER</span>
      </a>
      } @else {
      <app-go-back-btn (goBack)="goBack()"></app-go-back-btn>
      }
    </div>
    <div class="py-12 w-full max-w-sm mx-auto">
      @switch (currentStateType) { @case (LoginState.login) {
      <ng-container [ngTemplateOutlet]="loginTemplate"></ng-container>
      } @case (LoginState.confirmInformation) {
      <ng-container
        [ngTemplateOutlet]="confirmInformationTemplate"
      ></ng-container>
      } @case (LoginState.accountDetected) {
      <ng-container [ngTemplateOutlet]="accountDetectedTemplate"></ng-container>
      } @case (LoginState.toAccess) {
      <ng-container [ngTemplateOutlet]="toAccessTemplate"></ng-container>
      } @case (LoginState.phoneVerification) {
      <ng-container
        [ngTemplateOutlet]="phoneVerificationTemplate"
      ></ng-container>
      } @case (LoginState.finish) {
      <ng-container [ngTemplateOutlet]="finishTemplate"></ng-container>
      } @default {
      <ng-container [ngTemplateOutlet]="defaultTemplate"></ng-container>
      } }
    </div>
  </section>

  <!-- Lado derecho - Imagen estática -->
  <div class="hidden lg:block lg:w-3/5 h-full">
    <img
      src="/images/login/banner-derecho.webp"
      alt="Banner promocional ALLAS REPUESTOS"
      class="w-full h-full object-cover"
      title="ALLAS REPUESTOS - Servicios automotrices"
    />
  </div>
</main>

<!-- Login Step Template -->
<ng-template #loginTemplate>
  <app-login role="form" aria-label="Formulario de inicio de sesión">
  </app-login>
</ng-template>

<!-- Confirm Information Step Template -->
<ng-template #confirmInformationTemplate>
  <app-confirm-information role="form" aria-label="Confirmación de información">
  </app-confirm-information>
</ng-template>

<!-- Phone Account Detected Step Template -->
<ng-template #accountDetectedTemplate>
  <app-account-detected role="dialog" aria-label="Cuenta telefónica detectada">
  </app-account-detected>
</ng-template>

<!-- To Access Step Template -->
<ng-template #toAccessTemplate>
  <app-to-access role="form" aria-label="Solicitud de acceso"> </app-to-access>
</ng-template>

<!-- Validate Phone Step Template -->
<ng-template #phoneVerificationTemplate>
  <app-phone-verification
    role="form"
    aria-label="Validación de teléfono"
  ></app-phone-verification>
</ng-template>

<!-- Finish Step Template -->
<ng-template #finishTemplate>
  <app-finished
    (onClose)="reloadPage()"
    [show]="LoginState.finish === currentStateType"
    role="dialog"
    aria-label="Proceso completado"
  >
  </app-finished>
</ng-template>

<!-- Default Template -->
<ng-template #defaultTemplate>
  <app-login
    role="form"
    aria-label="Formulario de inicio de sesión"
  ></app-login>
</ng-template>
